import { createFileRoute } from "@tanstack/react-router"
import { BillingPage } from "@/money"

export const Route = createFileRoute("/(user)/t/$tenantSlug/billing")({
  component: RouteComponent,
})

function RouteComponent() {
  return <BillingPage />
}
